package com.vidaensupalabra.vsp.datos

import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.engine.js.*
import io.ktor.client.plugins.contentnegotiation.*
import io.ktor.client.request.*
import kotlinx.coroutines.CancellationException
import io.ktor.serialization.kotlinx.json.*
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.serialization.Serializable

@Serializable
data class MultimediaItem(
    val name: String,
    val url: String,
    val mimeType: String,
    val date: String? = null
)

object MultimediaRepository {
    private val _multimediaFlow = MutableStateFlow<List<MultimediaItem>>(emptyList())
    val multimediaFlow = _multimediaFlow.asStateFlow()
    private var isDataLoaded = false

    private val client = HttpClient(Js) {
        install(ContentNegotiation) {
            json()
        }
    }

    suspend fun loadDataIfNeeded() {
        if (!isDataLoaded) {
            try {
                _multimediaFlow.value = client.get("files/multimedia.json").body()
                isDataLoaded = true
            } catch (e: CancellationException) {
                throw e
            } catch (e: Exception) {
                println("Error loading multimedia data: ${e.message}")
            }
        }
    }
}